import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    Row, Col, Card, Button, DatePicker, Select, Avatar,
    Form, Radio, Input,
    Divider
} from 'antd';
import moment from 'moment';
import './style.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../Context';
import { Content } from 'antd/es/layout/layout';
import CustomSpin from '../CommonSpin';
import noProfile from '../../Images/noProfile.png';
import { clearOndemandData, ondemandRequest } from './Actions';
import { selectLoading, selectSuccessData } from './Selectors';
import { BodyTextKey, ButtonText } from '../CommonText';
import CustomTimePicker from './CustomTimePicker';

import english from '../../Translations/English.json';
import hindi from '../../Translations/Hindi.json';
import malayalam from '../../Translations/Malayalam.json';

const { Option } = Select;
const { TextArea } = Input;

const OnDemand = () => {
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {state} = useLocation();
    const {familyGet, familyDetails, getOrgFees, orgFees, getOrgDoctors, orgDoctors} = useAuth();

    const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
    const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;

    let gutcDateTime = new Date().toISOString();
    let gmomentUTCTime = moment.utc(gutcDateTime);
    let gfultime = gmomentUTCTime.add(5, 'hours').add(30, 'minutes');

    let feeTypeId;
    if (state?.payload?.consultType === 'walk') {
        if (state?.payload?.selectedResidence === 'INTERNATIONAL'){
            feeTypeId = 10;
        } else if(state?.payload?.selectedResidence === 'NRI'){
            feeTypeId = 12;
        } else { 
            feeTypeId = 2;
        }
    }

    if (state?.payload?.consultType === 'online') {
        if (state?.payload?.selectedResidence === 'INTERNATIONAL'){
            feeTypeId = 9;
        } else if(state?.payload?.selectedResidence === 'NRI'){
            feeTypeId = 11;
        } else {
            feeTypeId = 4;
        }
    }

    useEffect(() => {
        if(state?.payload)  {
            familyGet(state?.payload?.patientId);
            getOrgFees(state?.payload?.doctorID, feeTypeId);
            getOrgDoctors(state?.payload?.doctorID);
        }
        dispatch(clearOndemandData());
    },[]);    
    
    const [states, setState] = useState({
        time: null,
        date: null,
        conid: null,
        duration: null,
        patientssId: state?.payload?.patientId,
        microId: 1,
        notes: null,
        radioBtn: 'convinience',
        docId : state?.payload?.doctorID,
        selectedResidence : state?.payload?.selectedResidence,
        consultType : state?.payload?.consultType,
    });

    

    const requesting = useSelector(selectLoading);
    const dataa = orgDoctors?.data;
    const microClinicDetails = [];
    const successData = useSelector(selectSuccessData);

    if(successData) {
        navigate('/online-doctors-consultation');
    }

    const selectedPatientId = state?.payload?.patientId;

    const patientName = [];
    if (familyDetails) {
        familyDetails && familyDetails.map((item) => {
            patientName.push({
                value: item.id,
                label: `${item.firstName} ${item.lastName}`
            });
        });
    }

    const onDateChange = (date, dateString) => {
        setState(prev => ({ ...prev, date: dateString,  time: null }));
        form.setFields([
            {
                name: 'Time',
                errors: [],
                touched: false
            }
        ]);
    };

    const onTimeChange = (value) => {
        if (!value) {
            setState(prev => ({ ...prev, time: null }));
            return;
        }
        const [hour, minute, period] = value.split(':');
        const time24 = moment(`${hour}:${minute} ${period}`, 'h:mm A').format('HH:mm:ss');
        setState(prev => ({
            ...prev,
            time: time24
        }));
    };

    const onDurationChange = (value) => {
        setState(prev => ({ ...prev, duration: value }));
    };

    const onChangeReason = (e) => {
        setState(prev => ({ ...prev, notes: e.target.value }));
    };

    const consultChange = (e) => {
        setState(prev => ({ ...prev, radioBtn: e.target.value }));
    };

    const selectClinic = (value) => {
        setState(prev => ({ ...prev, microId: value }));
        localStorage.setItem('MICROCLINIC_ID', value);
    };

    const disabledDate = (current) => {
        return current && current < moment().subtract(1, 'days').endOf('day');
    };

    const handleSubmit = () => {
        
        form.validateFields().then(() => {
            const payload = { ...states };
            dispatch(ondemandRequest(payload));
            
            if (!sessionStorage.jwt) {
                navigate('/login');
            }
        });
    };

    const finalAmount = (() => {
        if (!orgFees || orgFees.total === 0) return null;

        const data = orgFees.data[0];
        const consultationFee = data.amount;
        if (data.organisation.quikdrFeeType === 'Fixed') {
            return consultationFee;
        } else if (data.organisation.quikdrFeeType === 'Variable') {
            return consultationFee;
        }
        return null;
    })();    

    const doctorCards = dataa?.map((item, index) => (
        <Card key={index} style={{ margin: '20px', borderRadius: '8px' }}>
            <Row gutter={24}>
                <Col 
                    xs={{ span: 24, offset: 0 }}
                    sm={{ span: 24, offset: 0 }} 
                    md={{ span: 8, offset: 0 }}
                    lg={{ span: 8, offset: 0 }}
                    xl={{ span: 8, offset: 0 }}
                    xxl={{ span: 8, offset: 0 }}
                    // span={8} 
                    style={{ textAlign: 'center', marginTop: '15px' }}>
                    <Avatar
                        size={120}
                        src={item?.doctor?.profilephotourl ? item?.doctor?.profilephotourl : noProfile}
                        style={{
                            borderWidth: 2,
                            borderColor: '#CACACA',
                            borderStyle: 'double',
                        }}
                    />
                    <div style={{ marginTop: '30px', textAlign : 'start' }}>
                        <div style={{ marginTop : '10px'}}>
                            <BodyTextKey text = {langdata.DoctorNameC ? langdata.DoctorNameC : 'Doctor Name:'} /> {`${item.doctor.initials} ${item.doctor.firstName} ${item.doctor.lastName}`}</div>
                        <div style={{ marginTop : '10px'}}>
                            <BodyTextKey text = {langdata.QualificationC ? langdata.QualificationC : 'Qualification: '} /> {item.doctor.descriptions}</div>
                        <div style={{ marginTop : '10px'}}>
                            <BodyTextKey text = {langdata.SpecialityC ? langdata.SpecialityC : 'Speciality: ' }/> {item.doctor.specialization.specialization}</div>
                        {finalAmount && <div style={{ marginTop : '10px'}}>
                            <BodyTextKey text = {langdata.ConsultationAmountC ? langdata.ConsultationAmountC : 'Consultation Amount:'} /> ₹ {finalAmount}</div>}
                    </div>
                </Col>
                <Col
                    xs={{ span: 0, offset: 0 }}
                    sm={{ span: 0, offset: 0 }} 
                    md={{ span: 1, offset: 0 }}
                    lg={{ span: 1, offset: 0 }}
                    xl={{ span: 1, offset: 0 }}
                    xxl={{ span: 1, offset: 0 }}>
                    <Divider type="vertical" style={{ height: '800px' }} />                
                </Col>
                <Col 
                // span={15}
                    xs={{ span: 24, offset: 0 }}
                    sm={{ span: 24, offset: 0 }} 
                    md={{ span: 15, offset: 0 }}
                    lg={{ span: 15, offset: 0 }}
                    xl={{ span: 15, offset: 0 }}
                    xxl={{ span: 15, offset: 0 }}
                >
                    <Form form={form} layout="vertical" onFinish={handleSubmit}>
                        <Row style={{ margin : '5px'}}>
                            <BodyTextKey text = {langdata.ConsultationTypeC ? langdata.ConsultationTypeC : 'Consultation Type : '} />&nbsp; {langdata.RequestConsultOnline ? langdata.RequestConsultOnline : 'Request Consult Online' }
                        </Row>
                        <Row style={{ margin : '5px'}}>
                            <BodyTextKey text = {langdata.TypeofResidence ? langdata.TypeofResidence : 'Type of Residence :'} /> &nbsp;{state?.payload?.selectedResidence}
                        </Row>
                        <Form.Item label={<BodyTextKey text = {langdata.Consultat ? langdata.Consultat : 'Consult at'} />} name="consultAt" rules={[{ required: true }]}>
                            <Radio.Group onChange={consultChange} value={states.radioBtn}>
                                <Radio value="convinience">{langdata.FromYourHomeComputerorSmartMobilePhone ? langdata.FromYourHomeComputerorSmartMobilePhone : 'From Your Home Computer or Smart Mobile Phone' }</Radio>
                            </Radio.Group>
                        </Form.Item>

                        {states.radioBtn === 'telemedicine' && (
                            <Form.Item label={<BodyTextKey text = {langdata.SelectTelemedicinecenter ? langdata.SelectTelemedicinecenter : 'Select Telemedicine center'} />} name="microclinic" rules={[{ required: true }]}>
                                <Select onChange={selectClinic}>
                                    {microClinicDetails?.value?.map(clinic => (
                                        <Option key={clinic.id} value={clinic.id}>
                                            {clinic.name}, {clinic.address}, {clinic.locality}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        )}

                        <Form.Item label={<BodyTextKey text = {langdata.PatientName ? langdata.PatientName : 'Patient Name'} />}>
                            <Select value={selectedPatientId} disabled options={patientName}>                            
                            </Select>
                        </Form.Item>

                        <Form.Item label={<BodyTextKey text = {langdata.Date ? langdata.Date : 'Date'} /> } name="Date" rules={[{ required: true }]}>
                            <DatePicker 
                                placeholder={langdata.Selectdate ? langdata.Selectdate : 'Select date'}
                                onChange={onDateChange} 
                                disabledDate={disabledDate} 
                                style={{ width: '100%' }} />
                        </Form.Item>

                        <Form.Item 
                            label={<BodyTextKey text={langdata.Time ? langdata.Time : 'Time'} />} 
                            name="Time" 
                            validateTrigger={['onSubmit']}
                            
                            rules={[
                                { 
                                    required: true,
                                    message: langdata.PleaseSelectTime ? langdata.PleaseSelectTime : 'Please select time',
                                    validator: async () => {
                                        if (!states.time) {
                                            return Promise.reject(new Error(langdata.PleaseSelectTime ? langdata.PleaseSelectTime : 'Please select time'));
                                        }
                                        return Promise.resolve();
                                    }
                                }
                            ]}
                        >
                            <CustomTimePicker
                                value={states.time ? moment(states.time, 'HH:mm:ss').format('h:mm:A') : null}
                                onChange={onTimeChange}
                                defaultOpenValue={moment(`${gfultime.hour()}:${gfultime.minute()}`, 'HH:mm')}
                                disabledDate={!states.date}
                                selectedDate={states.date}
                                hourLabel={langdata.Hour ? langdata.Hour : 'Hour'}
                                minuteLabel={langdata.Minute ? langdata.Minute : 'Minute'}
                                ampmLabel={langdata.AMPM ? langdata.AMPM : 'AM/PM'}
                            />
                        </Form.Item>

                        <Form.Item label={<BodyTextKey text = {langdata.Duration ? langdata.Duration : 'Duration'} />} name="Duration" rules={[{ required: true }]}>
                            <Select onChange={onDurationChange} placeholder={langdata.Selectduration ? langdata.Selectduration : 'Select duration'}>
                                <Option value="10">10</Option>
                                <Option value="15">15</Option>
                                <Option value="30">30</Option>
                                <Option value="60">60</Option>
                            </Select>
                        </Form.Item>

                        <Form.Item label={<BodyTextKey text = {langdata.Notes ? langdata.Notes : 'Notes'} />} name="Notes" rules={[{ required: true }]}>
                            <TextArea
                                placeholder={langdata.Headacheforpast10days ? langdata.Headacheforpast10days : 'Headache for past 10 days'}
                                onChange={onChangeReason}
                                autoSize={{ minRows: 2, maxRows: 4 }}
                            />
                        </Form.Item>

                        <div style={{ marginBottom: 15 }}>
                            <a 
                                onClick={() => navigate(('/ondemandhealthrecupload'),{state})}
                            >
                                {langdata.Doyouhaveanyhealthrecord ? langdata.Doyouhaveanyhealthrecord : 'Do you have any health record?' }
                            </a>
                        </div>

                        <Form.Item>
                            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                                <Button
                                    style={{ 
                                        borderRadius: '4px',
                                        padding: '4px 15px',
                                        height: '32px'
                                    }}
                                    onClick={() => {
                                        navigate(('/online-doctors-consultation'),{state: state.payload.initialSearchParams});
                                    }}
                                >
                                    <ButtonText text={langdata.Cancel ? langdata.Cancel : 'Cancel'} color='#000000' />
                                </Button>
                                <Button 
                                    type="primary"
                                    htmlType="submit"
                                    style={{ 
                                        borderRadius: '4px',
                                        padding: '4px 20px',
                                        height: '32px',
                                        background: '#0085FF'
                                    }}
                                >
                                    <ButtonText text={langdata.RequestAppointment ? langdata.RequestAppointment : 'Request Appointment'} />
                                </Button>
                            </div>
                        </Form.Item>
                    </Form>
                </Col>
            </Row>
        </Card>
    ));

    return (
        <Content>
            <Row justify={'center'}
                style={{
                    marginBottom: '1%',
                    display: 'flex',
                    justifyContent: 'center'
                }}>
                <Col lg={{ span: 16, offset: 0 }} xl={{ span: 16, offset: 1 }} md={{ span: 22 }}>
                    {doctorCards}
                </Col>
            </Row>
            <CustomSpin spinning={requesting} />
        </Content>
    );
};

export default OnDemand;